<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="自动发起考核任务"
      destroy-on-close
      :visible.sync="dialogShow"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-table :data="receivablesData" border>
          <el-table-column width="200" label="考核阶段" property="data_id">
            <template v-slot="{ row, $index }">
              <el-select v-model="row.data_id" placeholder="请选择" disabled style="width: 100%">
                <el-option v-for="item in khjdList" :key="item.key" :label="item.name" :value="item.key"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" property="valid_ids" label="是否自动发起">
            <template v-slot="{ row, $index }">
              <el-switch v-model="row.valid_ids" active-text="是" inactive-text="否" inactive-value="0" active-value="1"></el-switch>
            </template>
          </el-table-column>
          <el-table-column property="valid_names" label="自动触发比例(%)">
            <template v-slot="{ row, $index }">
              <el-input-number v-if="row.valid_ids == 1" v-model="row.valid_names" clearable :controls="false" :min="0" style="width: 100%"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column property="valid_type" label="自动发起对象">
            <template v-slot="{ row, $index }">
              <el-select v-if="row.valid_ids == 1" v-model="row.valid_type" placeholder="请选择" multiple style="width: 100%">
                <el-option v-for="item in assessmentSourceList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  data() {
    return {
      dialogShow: false,
      drawerSize: '70%',
      tenantId: '-1',
      loading: false,
      showPerson: false,
      noticeTimeShow: false,
      dimensionOptions: [],
      receivablesData: [],
      dataIdList: [],
      assessmentSourceList: [],
      khjdList: [],
      formData: []
    }
  },
  methods: {
    // 根据租户获取应收账款配置
    getReceivableCalculation() {
      let that = this
      that.dialogShow = true
      that.receivablesData = []
      that.$http.get('${portal}/portal/data_switch_config/getByKey?typeKey=project_department_assessment').then((resp) => {
        that.$nextTick(() => {
          if (resp && resp.data) {
            that.khjdList = utils.findDictList('khjd', that.allDataDict)
            that.assessmentSourceList = utils.getAllEnumerateAttr({
              isShowList: true,
              typeKey: 'AssessmentSourceProjectEnum',
              allData: that.allEnumerate
            })
            this.formData = resp.data
            if (resp.data.sub_data_switch_config_detail && resp.data.sub_data_switch_config_detail.length === 0) {
              that.khjdList.forEach((items) => {
                that.receivablesData.push({
                  refId: this.formData.id,
                  data_id: items.key,
                  label: items.name,
                  valid_ids: '',
                  valid_names: '0',
                  valid_type: []
                })
              })
            } else {
              that.receivablesData = resp.data.sub_data_switch_config_detail.map((items, index) => {
                items.valid_type = items.valid_type ? items.valid_type.split(',') : []
                items.valid_names = utils.isEmpty(items.valid_names) ? 0 : items.valid_names * 100
                return items
              })
            }
          }
        })
      })
    },
    //重置必填项
    resetFields() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    //关闭表单
    handleClose() {
      this.dialogShow = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      let flag = true
      let tempValue = JSON.parse(JSON.stringify(this.receivablesData))
      let temp = tempValue.map((items) => {
        items.valid_type = items.valid_type.join(',')
        items.valid_names = utils.isEmpty(items.valid_names) ? 0 : items.valid_names / 100
        if (flag && items.valid_ids == 1) {
          if (!items.valid_names) {
            flag = false
          }
          if (!items.valid_type) {
            flag = false
          }
        }
        return items
      })
      if (!flag) {
        this.$message.error('请填写自动触发比例或者自动发起对象！')
        return
      }
      this.loading = true
      this.$http
        .put('${portal}/portal/data_switch_config_detail/updateList', temp)
        .then((res) => {
          if (res.data.state) {
            this.loading = false
            this.$message.info('保存成功！')
          } else {
            this.loading = false
            this.$message.error('保存失败！')
          }
          this.handleClose()
        })
        .catch(() => {
          this.loading = false
        })
    },
    changeValid(index, value, key) {
      this.$set(this.receivablesData[index], key, value)
      this.$forceUpdate()
    },
    //设置提醒人关闭
    close() {
      this.showPerson = false
    }
  }
}
</script>

<style scoped></style>
